import ajax from "./ajax";

export function getNotifications() {
  return ajax(`Notification?sort=-id&per-page=100&page=1`);
}

// export function markNotificationsViewed(id) {
//   return ajax(`/Notification/mark-all-read`, { method: "POST", data: {
//     id,
//     is_viewed: 1
//   } });
// }

export function markNotificationsViewed(id) {
  return ajax(`/Notification/${id}/mark-read`, { method: "GET" });
}

export function deleteNotification(id) {
  return ajax(`/Notification/${id}`, { method: "DELETE" });
}   